import html2pdf from 'html2pdf.js';
import { Chapter } from '@/lib/types/book';

interface StudyGuideContent {
  title: string;
  chapters: Array<{
    title: string;
    content: string;
    isActive: boolean;
    concepts: Array<{
      title: string;
      description: string;
    }>;
    takeaways: string[];
  }>;
}

export class PDFService {
  static async generateStudyGuide(content: StudyGuideContent) {
    const html = `
      <div style="font-family: system-ui, -apple-system, sans-serif; max-width: 800px; margin: 0 auto; padding: 2rem;">
        <h1 style="font-size: 2.5rem; color: #1a1a1a; margin-bottom: 2rem; text-align: center;">${content.title}</h1>
        
        <div style="page-break-after: always;">
          <h2 style="font-size: 1.8rem; color: #1a1a1a; margin-bottom: 1.5rem;">Table of Contents</h2>
          <ul style="list-style-type: none; padding: 0;">
            ${content.chapters.map((chapter, index) => `
              <li style="margin-bottom: 0.5rem;">
                <span style="color: #0056D2; margin-right: 0.5rem;">${index + 1}.</span>
                <span style="color: #1a1a1a;">${chapter.title}</span>
              </li>
            `).join('')}
          </ul>
        </div>

        ${content.chapters.map((chapter, index) => `
          <div style="margin-bottom: 3rem; page-break-before: always;">
            <h2 style="font-size: 2rem; color: #2D7FFF; margin-bottom: 1.5rem; display: flex; align-items: center;">
              <span style="background: #0056D2; color: white; width: 2.5rem; height: 2.5rem; display: inline-flex; align-items: center; justify-content: center; border-radius: 50%; margin-right: 1rem;">${index + 1}</span>
              ${chapter.title}
            </h2>
            
            <div style="margin-bottom: 2rem;">
              <h3 style="font-size: 1.5rem; color: #1a1a1a; margin-bottom: 1rem;">Key Concepts</h3>
              ${chapter.concepts.map(concept => `
                <div style="margin-bottom: 1.5rem; padding: 1rem; border: 2px solid #E8F1FF; border-radius: 0.5rem;">
                  <h4 style="font-size: 1.25rem; color: #0056D2; margin-bottom: 0.5rem;">${concept.title}</h4>
                  <p style="font-size: 1.1rem; color: #4a4a4a; line-height: 1.6;">${concept.description}</p>
                </div>
              `).join('')}
            </div>

            <div style="margin-bottom: 2rem;">
              <h3 style="font-size: 1.5rem; color: #1a1a1a; margin-bottom: 1rem;">Detailed Notes</h3>
              <p style="font-size: 1.1rem; color: #4a4a4a; line-height: 1.6;">${chapter.content}</p>
            </div>

            <div style="margin-bottom: 2rem;">
              <h3 style="font-size: 1.5rem; color: #1a1a1a; margin-bottom: 1rem;">Chapter Takeaways</h3>
              <ul style="list-style-type: none; padding: 0;">
                ${chapter.takeaways.map(takeaway => `
                  <li style="display: flex; align-items: start; gap: 0.75rem; margin-bottom: 1rem;">
                    <div style="width: 8px; height: 8px; background: #2D7FFF; border-radius: 50%; margin-top: 0.5rem;"></div>
                    <p style="font-size: 1.1rem; color: #4a4a4a; line-height: 1.6; margin: 0;">${takeaway}</p>
                  </li>
                `).join('')}
              </ul>
            </div>
          </div>
        `).join('')}
      </div>
    `;

    // Create a temporary container
    const container = document.createElement('div');
    container.innerHTML = html;

    const opt = {
      margin: 0.5,
      filename: `${content.title.toLowerCase().replace(/\s+/g, '-')}-study-guide.pdf`,
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    try {
      await html2pdf().set(opt).from(container).save();
      return true;
    } catch (error) {
      console.error('Failed to generate PDF:', error);
      throw error;
    }
  }
} 